(function () {
    'use strict';

    angular.module('app.widgets')
        .component('appPermissions', {
            bindings: {
                application: '<',
                onModelChanged: '&',
                onEdit: '&'
            },
            controller: AppPermissionsController,
            controllerAs: 'vm',
            templateUrl: 'app/widgets/app-permissions/app.permissions.component.html'
        });

    /* @ngInject */
    function AppPermissionsController() {
        var vm = this;         

        vm.edit = edit;
        vm.undo = undo;
        vm.save = save;        
        
        function save(application) {
            if (!application.access) {
                application.selectedRoles = [];
            }
            application.edited = false;
            vm.onEdit();
            copyOriginalDetails(application);
            
            vm.onModelChanged({
                application: {
                    ApplicationId: application.ApplicationId,
                    ApplicationName: application.ApplicationName,
                    HasAccess: application.access,
                    SelectedRoles: application.selectedRoles
                }
            });
        }

        function edit(application) {
            application.edited = true;
            vm.onEdit();
            copyOriginalDetails(application);           
        }

        function undo(application) {
            application.selectedRoles = angular.copy(application.original.selectedRoles);
            application.access = application.original.access;
        }

        function copyOriginalDetails(application) {
            application.original.access = application.access;
            application.original.selectedRoles = angular.copy(application.selectedRoles);
            application.original.editited = application.edited;
        }        
    }
})();
